module.exports = __webpack_public_path__ + "24cf6e849a0ea31bd70397e078e64ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-26.jpg
// module id = 1167
// module chunks = 0